import { API_URL } from '../config/api';

export const createContent = async (data: { title: string, type: string, primary_language: string }, token: string) => {
  const response = await fetch(`${API_URL}/contents`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      ...data,
      slug: `${data.type}-${Date.now()}` // توليد رابط مبدئي
    })
  });

  if (!response.ok) throw new Error('فشل في إنشاء المحتوى');
  return response.json();
};

export const addSceneToContent = async (contentUuid: string, sceneData: any, token: string) => {
  const response = await fetch(`${API_URL}/contents/${contentUuid}/scenes`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(sceneData)
  });

  if (!response.ok) throw new Error('فشل في إضافة المشهد');
  return response.json();
};